// extracted by mini-css-extract-plugin
export default {"menuToggle":"JxHGmw","toggleOpen":"HoyfNC","buttonContainer":"fo6j2q","menu-icon":"BCbKRj","menuIcon":"BCbKRj"};